export const FREEDOME_ROUTINE = [
  {
    id: 1,
    title: 'Делегирование задач:',
    descr:
      'Персональный менеджер возьмет на себя процесс оформления и ведения сделки и при необходимости свяжется с вами или вашим клиентом для согласования деталей',
    list: [],
    imageClass: 'home',
  },
  {
    id: 2,
    title: 'Контроль через личный кабинет',
    descr: 'Вы будете в курсе каждого этапа и сможете информировать клиента о статусе сделки',
    list: [],
    imageClass: 'desktop',
  },
];
